import axios from 'axios';
import _ from 'lodash';

import cfg from '../config';

export const FILES_GET_FILES = "files/GET_FILES";


const initialState = {
  // Objects not arrays!
  files: {},
  timestamp: Date.now()
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FILES_GET_FILES:
      return {
        ...state,
        files: _.cloneDeep(action.data),
        timestamp: Date.now()
      };
    default:
      return state;
  }
}

/* */
export const getFiles = () => {
  return dispatch => {
      axios.get(cfg.api.getProcess)
      .then((response) => {
          dispatch({type: FILES_GET_FILES, data: response.data });
      })
      .catch((error) => {
         console.log(error);
         dispatch({type: FILES_GET_FILES, data: {}});
      });
  }
}



// WEBPACK FOOTER //
// ./src/reducers/files.js